/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter, useRoutes } from 'react-router-dom'

import { CSpinner, useColorModes } from '@coreui/react'
import routes from './routes'
import './scss/style.scss'
import { useAuthStore } from './store/useAuthStore/useAuthStore'

const App = () => {
  const initializeKeycloak = useAuthStore((s) => s.initializeKeycloak)

  React.useEffect(() => {
    initializeKeycloak()
  }, [])

  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')
  const storedTheme = useSelector((state) => state.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function AppRoutes() {
    return useRoutes(routes)
  }

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
